import Axios from 'axios';
import {ensureSessionOrRedirect} from './session';

Axios.interceptors.request.use(
  (config) => {
    if (!ensureSessionOrRedirect()) {
      throw new Axios.Cancel('Session expired');
    }
    return config;
  },
  (error) => Promise.reject(error),
);
